module.exports = __webpack_public_path__ + "img/left-arrow-back-qna.985845eb.svg";